<div class="resend-container">
  <div class="text-center v-text-caption">認証メールが届かない方</div>
  <a (click)="doNavigate()" class="text-link v-text-caption">メール再送信</a>
</div>
